import { FC, useEffect } from 'react';

type TSiteBackgroundOverrideProps = {
  imageUrl: string;
};

export const SiteBackgroundOverride: FC<TSiteBackgroundOverrideProps> = ({ imageUrl }) => {
  // show a background if coming in with proper params
  useEffect(() => {
    // set the page backdrop
    const elem = document.getElementById('application');
    if (elem) {
      elem.style.background = `url(${imageUrl}) repeat`;
    }

    // clear the background when we leave the page
    return () => {
      const el = document.getElementById('application');
      if (el) {
        el.style.background = '';
      }
    };
  }, [imageUrl]);

  return null;
};
